import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ImovelPage from '../../components/ImovelPage';

const Imovel = () => {
  const { slug } = useParams();
  const [imovel, setImovel] = useState(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const buscarImovel = async () => {
      try {
        const resposta = await fetch(`${process.env.REACT_APP_API_URL}/index.php?rota=imoveis&slug=${slug}`);
        const dados = await resposta.json();
        if (dados.sucesso && dados.imovel)
          setImovel(dados.imovel);
        else
          setImovel(null);
      } catch (erro) {
        console.error('Erro ao buscar imóvel:', erro);
      } finally {
        setCarregando(false);
      }
    };

    buscarImovel();
  }, [slug]);

  if (carregando) return <p>Carregando...</p>;
  if (!imovel) return <p>Imóvel não encontrado.</p>;

  return <ImovelPage imovel={imovel} />;
};

export default Imovel;